export const team = [
    {
        name: 'Maya Okafor',
        role: 'Founder and Chief Forecaster',
        image: '/images/team/portrait-woman-1.jpg',
        position: '50% 30%',
        fact: 'Predicted the return of the flip phone in 2023. Still bringing it up at dinner.'
    },
    {
        name: 'Ines Duarte',
        role: 'Creative Director',
        image: '/images/team/portrait-woman-2.jpg',
        position: '50% 22%',
        fact: 'Lays out every carousel like a magazine spread. Has opinions about kerning on a phone.'
    },
    {
        name: 'Theo Lindqvist',
        role: 'Head of Video',
        image: '/images/team/portrait-man-1.jpg',
        position: '50% 40%',
        fact: 'Once filmed a launch on a phone taped to a broom. It got 1.4 million views.'
    },
    {
        name: 'Ravi Mehta',
        role: 'Data and Performance Lead',
        image: '/images/team/portrait-man-3.jpg',
        position: '50% 12%',
        fact: 'Keeps a dashboard for his allotment. The courgettes are outperforming forecast.'
    },
    {
        name: 'Gus Harrow',
        role: 'Producer and Keeper of the Calendar',
        image: '/images/team/portrait-man-2.jpg',
        position: '50% 20%',
        fact: 'Has never missed a deadline. Has also never been seen without a lanyard.'
    }
]

export const values = [
    { word: 'Bold', line: 'One idea people remember beats ten they scroll straight past.' },
    { word: 'Fast', line: 'The feed moves in hours. We keep up without cutting the corners that matter.' },
    { word: 'Honest', line: 'We report the flops as loudly as the wins. That is how the next one lands.' },
    { word: 'Curious', line: 'We ask why things work, then test what might work next. Mostly on Fridays.' }
]

export const milestones = [
    { year: '2019', title: 'A kitchen table in Peckham', body: 'Maya leaves ad buying, starts Updraft with one client, one phone and a lot of borrowed lighting.' },
    { year: '2020', title: 'The first forecast', body: 'A one page note predicting a boom in home cooking videos lands three new clients in a month.' },
    { year: '2021', title: 'A studio with a door', body: 'We move into Shoreditch Studios, build a shooting corner and become a team of seven.' },
    { year: '2022', title: 'Numbers join the party', body: 'Ravi arrives and the weekly read is born. Creative and data finally share a desk.' },
    { year: '2023', title: 'The Tuesday Signal', body: 'Our newsletter starts as a favour to clients and now reaches thousands of marketers a week.' },
    { year: '2024', title: 'The Lab opens', body: 'We start running small public experiments on hooks, thumbnails and captions, and sharing the results.' },
    { year: '2025', title: '200 campaigns in', body: 'Two hundred launches across six industries, and a retention rate we are quietly very proud of.' },
    { year: '2026', title: '61 million views', body: 'Client views pass sixty one million for the year and we open a small outpost in Lisbon.' }
]

export const tools = [
    'Figma',
    'CapCut',
    'Premiere Pro',
    'DaVinci Resolve',
    'Lightroom',
    'Notion',
    'Frame.io',
    'Airtable',
    'Metricool',
    'Meta Ads Manager',
    'TikTok Creative Center',
    'Descript',
    'A very old Polaroid',
    'Too many highlighters'
]

export const recognition = [
    { title: 'Small Studio of the Year', source: 'The Feed Awards 2025' },
    { title: 'Best Recurring Series, Pip & Ferment', source: 'Short Form Honours 2025' },
    { title: 'Ten studios to watch', source: 'Creator Economy Weekly' },
    { title: 'Why the jar went viral', source: 'Featured in The Content Brief' }
]
